export default __webpack_public_path__ + "static/media/arrow.c7b23125.svg";